import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import * as React from 'react';

import { AdfoxBannerAdditionalFilters } from '../../components/AdfoxBanner';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from '../../constants/adBannerMicrofrontend';
import { useApplicationContext } from '../../utils/applicationContext';
import { AdBannerMicrofrontendAdditionalFiltersContainer } from '../AdBannerMicrofrontendAdditionalFiltersContainer';

type TBannerAdditionalFiltersContainerProps = {
  onLoad(): void;
  onError(): void;
};

/**
 * Фича-флаговый шов: манифест в конфиге есть — рендерим микрофронтенд ad-banner-frontend,
 * нет — легаси-баннер на @cian/adfox-component.
 */
export const BannerAdditionalFiltersContainer: React.FC<TBannerAdditionalFiltersContainerProps> = ({
  onLoad,
  onError,
}) => {
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);

  return manifest ? (
    <AdBannerMicrofrontendAdditionalFiltersContainer manifest={manifest} onLoad={onLoad} onError={onError} />
  ) : (
    <AdfoxBannerAdditionalFilters onLoad={onLoad} onError={onError} />
  );
};
